<template>
  <div v-if="can('trips.edit')">
    <div class="cloading" v-show="is_loading_item"></div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">{{i18n('Dispatching')}}</a></li>
        <li class="breadcrumb-item">
          <router-link to="/trips">
            {{i18n('Trips')}}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page"> {{i18n('Creation')}}</li>
      </ol>
    </nav>

    <form action="" @submit.prevent="save()">
      <div class="base_box_hdr">
        <div class="base_box_ttl">
          <h1 class="title">{{i18n('Trips (creation)')}}</h1>
          <div v-if="is_loading_item">
            {{i18n('Loading data')}}...
          </div>
        </div>
        <div class="base_box_cnt">
          <div class="button-group">
            <button type="submit" class="btn base_btn solid_blue waves-effect waves-light">
              {{i18n('Save and close')}}
            </button>
          </div>
        </div>
      </div>
      <div class="base_box_cnt pb-0">
        <div class="row">
          <div class="col-xl-6 col-lg-10 col-md-12">
            <div class="form-group form-row">
              <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Route')}}:</label>
              <div class="col-xl-9 col-sm-8">
                <model-list-select :list="routes_list"
                                   v-model="route_id"
                                   option-value="id"
                                   :isDisabled="true"
                                   :custom-text="fullNameOfRoute"

                                   :placeholder="i18n('Select')">
                </model-list-select>
                <!--@select="handleRouteChange"-->

              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Departure time')}}:</label>
              <div class="col-xl-4 col-sm-8">
                <div class="day">
                  <div class="input-group">
                    <date-picker
                            v-model="time"
                            :disabled="true"
                            :auto="true"
                            :inputClass="'form-control base_input form-control'"
                            :bootstrap-styling="true"
                            :calendar-button="true"
                            calendar-button-icon="mdi mdi-calendar"
                            :config="options" class="m_datepicker"></date-picker>
                    <span class="vdp-datepicker__calendar-button input-group-prepend">
                      <span class="input-group-text"><i class="mdi mdi-calendar"></i></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="base_box_main">
        <div class="base_box mb-3">
          <div class="base_box_cnt">
            <h6>{{i18n('Registration')}}</h6>
            <div class="row">
              <div class="col-xl-12 col-lg-10 col-md-12">
                <div class="form-group form-row">
                  <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Transporters')}}:</label>
                  <div class="col-xl-9 col-sm-8">
                    <model-list-select :list="transporters_list"
                                       v-model="transporter_id"
                                       :custom-text="fullNameOfTransporter"
                                       option-value="id"
                                       :placeholder="i18n('Select')">
                    </model-list-select>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Bus')}}:</label>
                  <div class="col-xl-9 col-sm-8">
                    <model-list-select :list="buses_list"
                                       v-model="bus_id"
                                       option-value="id"
                                       :custom-text="fullNameOfBus"
                                       :placeholder="i18n('Select')">
                    </model-list-select>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Platform')}}:</label>
                  <div class="col-xl-9 col-sm-8">
                    <input type="text" class="form-control base_input" v-model="platform">
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Driver')}}:</label>
                  <div class="col-xl-9 col-sm-8">
                    <model-list-select :list="drivers_list"
                                       v-model="driver_id"
                                       option-value="id"
                                       option-text="name"
                                       :placeholder="i18n('Select')">
                    </model-list-select>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Driver')}} 2:</label>
                  <div class="col-xl-9 col-sm-8">
                    <model-list-select :list="drivers_list"
                                       v-model="driver_id2"
                                       option-value="id"
                                       option-text="name"
                                       :placeholder="i18n('Select')">
                    </model-list-select>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Driver')}} 3:</label>
                  <div class="col-xl-9 col-sm-8">
                    <model-list-select :list="drivers_list"
                                       v-model="driver_id3"
                                       option-value="id"
                                       option-text="name"
                                       :placeholder="i18n('Select')">
                    </model-list-select>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <nav>
          <div class="nav nav-tabs" role="tablist">
            <a class="nav-item nav-link active" id="nav-01-tab" data-toggle="tab" href="#nav-01-1" role="tab" aria-controls="nav-01-1" aria-selected="true">{{i18n('Price entry')}}</a>
            <a class="nav-item nav-link" id="nav-02-tab" data-toggle="tab" href="#nav-02-1" role="tab" aria-controls="nav-02-1" aria-selected="true">{{i18n('Baggage')}}</a>
          </div>
        </nav>

        <div class="tab-content">
          <div class="tab-pane fade show active" id="nav-01-1" role="tabpanel" aria-labelledby="nav-01-tab">
            <div class="row">
              <div class="col-xl-4 col-sm-8">
                <div class="form-group">
                  <label class="col-xl-4 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Price entry')}}:</label>
                  <div class="radioGroup" style="padding-top: 8px">
                    <div v-for="(type, key) in calculation_types"
                         class="custom-control custom-radio custom-control-inline">
                      <input type="radio" :id="'customRadioInline' + key"
                             v-model="payment_calculation_type"
                             name="customRadioInline" class="custom-control-input"
                             :value="parseInt(key)"
                             @change="calculatePrices"
                      >
                      <label class="custom-control-label" :for="'customRadioInline' + key">{{type}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-sm-8">
                <div class="form-group" v-if="payment_calculation_type === 1">
                <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Tariff')}}:</label>
                  <model-list-select :list="tariff_list"
                                     v-model="tariff_id"
                                     option-value="id"
                                     option-text="name"
                                     :placeholder="i18n('Select')">
                  </model-list-select>
                </div>
              </div>
            </div>
            <div class="table-wrapper" v-if="stations_list.length > 0" style="height: auto">
              <div class="table-responsive">
                <table class="table inputPrice">
                  <thead>
                  <tr>
                    <th scope="col" nowrap=""></th>
                    <th scope="col" v-for="(station, i) in stations_list" v-if="i > 0">
                      {{station.station ? station.station.name : ''}}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(station, i) in stations_list" v-if="i < stations_list.length - 1">
                    <td>{{station.station ? station.station.name : ''}}</td>
                    <td v-for="(stat, j) in stations_list" v-if="j > 0">
                      <input v-if="j > i" type="text" class="form-control"
                             v-model="trip_prices[i][j]"
                             @change="roundPrice(i, j)"
                             :disabled="payment_calculation_type === 1"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="nav-02-1" role="tabpanel" aria-labelledby="nav-02-tab">
            <div class="row">
              <div class="col-xl-4 col-sm-8">
                <div class="form-group">
                  <label class="col-xl-4 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Price entry')}}:</label>
                  <div class="radioGroup" style="padding-top: 8px">
                    <div v-for="(type, key) in calculation_types"
                         class="custom-control custom-radio custom-control-inline">
                      <input type="radio" :id="'baggage_price_calculation_typeRadioInline' + key"
                             v-model="baggage_price_calculation_type"
                             name="baggage_price_calculation_typeRadioInline" class="custom-control-input"
                             :value="parseInt(key)"
                             @change="calculateBaggagePrices"
                      >
                      <label class="custom-control-label" :for="'baggage_price_calculation_typeRadioInline' + key">{{type}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-sm-8">
                <div class="form-group" v-if="baggage_price_calculation_type === 1">
                  <label class="col-xl-3 col-lg-4 col-form-label fs-12 pt-12">{{i18n('Tariff')}}:</label>
                  <model-list-select :list="baggage_services_list"
                                     v-model="baggage_service_id"
                                     option-value="id"
                                     option-text="name"
                                     :placeholder="i18n('Select')"
                                     @input="calculateBaggagePrices"
                  >
                  </model-list-select>
                </div>
              </div>
            </div>
            <div class="table-wrapper" v-if="stations_list.length > 0" style="height: auto">
              <div class="table-responsive">
                <table class="table inputPrice">
                  <thead>
                  <tr>
                    <th scope="col" nowrap=""></th>
                    <th scope="col" v-for="(station, i) in stations_list" v-if="i > 0">
                      {{station.station ? station.station.name : ''}}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(station, i) in stations_list" v-if="i < stations_list.length - 1">
                    <td>{{station.station ? station.station.name : ''}}</td>
                    <td v-for="(stat, j) in stations_list" v-if="j > 0">
                      <input v-if="j > i" type="text" class="form-control"
                             v-model="baggage_prices[i][j]"
                             @change="roundPrice(i, j)"
                             :disabled="baggage_price_calculation_type === 1"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import SelectPicker from '../../components/SelectPicker';
    import FormInput from '../../components/FormInput';
    import {ModelListSelect} from 'vue-search-select';

    export default {
        name: "trips-update",
        components: {Datepicker, SelectPicker, FormInput, ModelListSelect},
        data() {
            return {
                options: {
                    format: 'Y-MM-DD H:mm',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    inline: false,
                    icons: {
                        time: 'mdi mdi-timer',
                        date: 'mdi mdi-timetable',
                        up: 'mdi mdi-chevron-up',
                        down: 'mdi mdi-chevron-down',
                        previous: 'mdi mdi-chevron-left',
                        next: 'mdi mdi-chevron-right',
                        today: 'mdi mdi-calendar-today',
                        clear: 'mdi mdi-delete',
                        close: 'mdi mdi-close-box'
                    }
                },
                routes_list: [],
                stations_list: [],
                buses_list: [],
                all_buses_list: [],
                drivers_list: [],
                all_drivers_list: [],
                tariff_list: [],
                transporters_list: [],
                route_id: '',
                bus_id: '',
                platform: '',
                driver_id: '',
                driver_id2: '',
                driver_id3: '',
                tariff_id: '',
                baggage_services_list: [],
                baggage_service_id: 0,
                trip_id: '',
                transporter_id: '',
                payment_calculation_type: 1,
                baggage_price_calculation_type: 2,
                time: this.$moment().format("YYYY-MM-DD H:mm"),
                calculation_types: [],
                trip_prices: [],
                trip_prices_update: [],
                baggage_prices: [],
                baggage_prices_update: [],
                free_baggage_allowance: 0,
                max_baggage_allowance: 0,
                price_for_save: [],
                baggage_prices_for_save: [],
                is_loading_item: false,
                loading_item_count: 0,
                baggageServicePricingTypes: {
                    TYPE_FIXED_PRICE: 1,
                    TYPE_PER_KM_PRICE: 2,
                    TYPE_PERCENT_PRICE: 3,
                }
            }
        },
        mounted() {
        },
        created() {
            Object.freeze(this.baggageServicePricingTypes);
            this.time = this.$store.state.trips.date || this.$moment().format("YYYY-MM-DD");
            this.is_loading_item = true;
            this.loadCalculationTypes();
            this.loadTariffs();
            this.loadBuses();
            this.loadDrivers();
            this.loadTransporters();
            this.loadTrip().then(res => {
                this.loadBaggageServices();
                this.loadRoutes();
            });
        },
        methods: {
            async loadTrip() {
                let id = this.$route.params.id;
                let params = {};
                if (id <= 0) {
                    return;
                }
                params.id = id;
                await this.$api.get('trips.show', params).then(({data}) => {
                    this.route_id = data.route_id;
                    this.is_international = data.is_international;
                    this.bus_id = data.bus_id;
                    this.platform = data.platform;
                    this.driver_id = data.driver_id;
                    this.driver_id2 = data.driver_id2;
                    this.driver_id3 = data.driver_id3;
                    this.tariff_id = data.tariff_id;
                    this.baggage_service_id = data.baggage_service_id;
                    this.transporter_id = data.transporter_id;
                    this.trip_id = data.id;
                    this.trip_prices_update = data.prices ? JSON.parse(data.prices.price) : [];
                    this.baggage_prices_update = !_.isEmpty(data.baggage_price) ? JSON.parse(data.baggage_price.price) : null;
                    this.payment_calculation_type = parseInt(data.payment_calculation_type);
                    if (data.baggage_price_calculation_type) {
                        this.baggage_price_calculation_type = data.baggage_price_calculation_type;
                    }
                    this.free_baggage_allowance = data.free_baggage_allowance;
                    this.max_baggage_allowance = data.max_baggage_allowance;
                    this.time = this.$moment(data.time).format("YYYY-MM-DD H:mm");
                    this.loading_item_count++;
                });
            },
            loadCalculationTypes() {
                this.$api.get('schedule-trips.calculation')
                    .then(res => {
                        this.calculation_types = res.data;
                        this.loading_item_count++;
                    });
            },
            loadRoutes() {
                this.$api.get('routes.all').then(({data}) => {
                    this.routes_list = data;
                    this.handleRouteChange();
                    this.loading_item_count++;
                });
            },
            loadBuses() {
                this.$api.get('trips.buses').then(({data}) => {
                    this.buses_list = Object.create(data);
                    this.all_buses_list = Object.create(data);
//alx
                    this.buses_list = this.all_buses_list.filter(bus => bus.transporter_id === this.transporter_id);
                    this.loading_item_count++;
                });
            },
            loadTariffs() {
                this.$api.get('trips.tariffs').then(({data}) => {
                    this.tariff_list = data;
                    this.loading_item_count++;
                });
            },
            async loadBaggageServices() {
                await this.$api.get('baggage.index')
                    .then(res => {
                        this.baggage_services_list = res.data;
                    });
            },
            loadDrivers() {
                this.$api.get('trips.drivers').then(({data}) => {
                    this.drivers_list = Object.create(data);
                    this.all_drivers_list = Object.create(data);
                    // TODO:                 
                    //let bus = this.all_buses_list.find(item => item.id === this.driver_id);
                    //this.drivers_list = this.all_drivers_list.filter(driver => driver.id === bus.driver_id);
                    this.loading_item_count++;
                });
            },
            loadTransporters() {
                this.$api.get('trips.transporters').then(({data}) => {
                    this.transporters_list = data;
                    this.loading_item_count++;
                });
            },
            fullNameOfRoute(route) {
                return route.name + ' (' + route.number + ')';
            },
            fullNameOfBus(bus) {
                return bus.bus_model + ' [' + bus.bus_number + '] - ' + bus.transporter;
            },
            fullNameOfTransporter(transporter) {
                return transporter.name;
            },
            save() {
                this.setTripPrice();
                this.setBaggagePrices();
                let postData = {};
                postData.route_id = this.route_id;
                postData.bus_id = this.bus_id;
                postData.platform = this.platform;
                postData.driver_id = this.driver_id;
                postData.driver_id2 = this.driver_id2;
                postData.driver_id3 = this.driver_id3;
                postData.tariff_id = this.tariff_id;
                postData.baggage_service_id = this.baggage_service_id;
                postData.trip_id = this.trip_id;
                postData.transporter_id = this.transporter_id;
                postData.payment_calculation_type = this.payment_calculation_type;
                postData.baggage_price_calculation_type = this.baggage_price_calculation_type;
                postData.prices = this.price_for_save;
                postData.baggage_prices = this.baggage_prices_for_save;
                postData.baggage_service_id = this.baggage_service_id;
                postData.price = this.trip_prices[0][this.trip_prices[0].length - 1];

                this.$api.post('trips.edit', postData, this.$route.params.id)
                    .then(res => {
                        this.$notify({
                            type: 'success',
                            group: 'foo',
                            title: this.i18n('Successfully!!!'),
                            text: this.i18n('Trip has been created successfully')
                        });
                        this.$router.replace({name: "trips.index"});
                    })
                    .catch(err => {
                        console.log(err);
                        if (err.response && err.response.status === 422) {
                            let text = '';
                            Object.keys(err.response.data.errors).forEach(field => {
                                text += err.response.data.errors[field].join(' ') + "<br/>";
                            });
                            this.$notify({
                                type: 'error',
                                group: 'foo',
                                title: err.response.data.message,
                                text: text
                            });
                        }
                    });
            },
            calculatePrices() {
                let tariff = this.tariff_list.find(item => item.id === this.tariff_id);
                let t_price = tariff ? parseInt(tariff.price_per_km) : 0;
                let per_price = 0;
                for (let i = 0; i < this.stations_list.length; i++) {
                    per_price = 0;
                    if (i < this.stations_list.length - 1) {
                        this.trip_prices[i] = [];
                        for (let j = 0; j < this.stations_list.length; j++) {
                            if (j > i) {
                                if (this.payment_calculation_type === 2) {
                                    let exist_price = this.trip_prices_update.find(price =>
                                        price.from === this.stations_list[i].station_id
                                        && price.to === this.stations_list[j].station_id
                                    );
                                    this.trip_prices[i][j] = exist_price ? parseInt(exist_price.price) : 0;
                                } else {
                                    per_price += parseInt(this.stations_list[j].distance) * t_price;
                                    this.trip_prices[i][j] = per_price;
                                }
                            }
                        }
                    }
                }
                this.$forceUpdate();
            },
            fillBaggagePricesWithZero() {
                for (let row = 0; row < this.stations_list.length; row++) {
                    if (row >= this.stations_list.length - 1) continue;
                    this.baggage_prices[row] = [];
                    for (let col = 0; col < this.stations_list.length; col++) {
                        if (col <= row) continue;
                        this.baggage_prices[row][col] = 0;
                    }
                }
            },
            fillBaggagePricesArray() {
                for (let row = 0; row < this.stations_list.length; row++) {
                    if (row >= this.stations_list.length - 1) continue;
                    this.baggage_prices[row] = [];
                    for (let col = 0; col < this.stations_list.length; col++) {
                        if (col <= row) continue;
                        let existPrice = this.baggage_prices_update.find(price =>
                            price.from === this.stations_list[row].station_id
                            && price.to === this.stations_list[col].station_id
                        );
                        this.baggage_prices[row][col] = existPrice ? parseInt(existPrice.price) : 0;
                    }
                }
                this.$forceUpdate();
            },
            calculateBaggagePrices() {
                if (!this.isBaggageServiceSelected()) {
                    return;
                }
                let baggageService = this.getBaggageService();
                this.setBaggageAllowanceFromBaggageService(baggageService);

                for (let row = 0; row < this.stations_list.length; row++) {
                    if (row >= this.stations_list.length - 1) continue;
                    this.baggage_prices[row] = [];
                    for (let col = 0; col < this.stations_list.length; col++) {
                        if (col <= row) continue;
                        // Matrix (baggage_prices) — a two-dimensional array of prices, which will be used to render the price table
                        // Intersection — the current pair of stations in the `matrix` for which the distance and the amount are calculated
                        let intersectionPrice = 0;
                        switch (baggageService.pricing_type) {
                            case this.baggageServicePricingTypes.TYPE_FIXED_PRICE:
                                intersectionPrice = baggageService.default_price_for_step;
                                break;
                            case this.baggageServicePricingTypes.TYPE_PERCENT_PRICE:
                                intersectionPrice =
                                    (this.trip_prices[row][col] / 100) * baggageService.percent;
                                break;
                            case this.baggageServicePricingTypes.TYPE_PER_KM_PRICE:
                                let currentIntersection = {
                                    row: this.stations_list[row],
                                    col: this.stations_list[col]
                                };
                                let distance = this.getDistance(currentIntersection);
                                intersectionPrice = this.getBaggagePrice(distance);
                                break;
                        }
                        this.baggage_prices[row][col] = intersectionPrice;
                    }
                }
                this.$forceUpdate();
            },
            getDistance(intersection) {
                let routeDetails = _.sortBy(this.stations_list, routeDetail => routeDetail.order);
                routeDetails = routeDetails.filter(routeDetail => {
                    return intersection.row.order < routeDetail.order &&
                        intersection.col.order >= routeDetail.order
                });
                return _.sumBy(routeDetails, routeDetail => +routeDetail.distance);
            },
            getBaggagePrice(intersectionDistance) {
                let baggageService = this.getBaggageService();
                let serviceOptions = baggageService.baggage_service_options;
                // TODO clarify that should I add `order` column for `baggage_service_options` table and sort by this column
                let maximumMarkedDistance = _.last(_.sortBy(serviceOptions, option => option.id)).distance;

                serviceOptions = serviceOptions.filter((opt, idx, arr) => {
                    let prevOptDistance = !_.isEmpty(arr[idx-1]) ? arr[idx-1].distance : 0;
                    return opt.distance <= intersectionDistance ||
                        (prevOptDistance < intersectionDistance && opt.distance > intersectionDistance);
                });
                let intersectionPrice = _.sumBy(serviceOptions, opt => opt.price_before_distance);

                if (intersectionDistance > maximumMarkedDistance) {
                    const distanceOverMarkedLimit = intersectionDistance - maximumMarkedDistance;
                    const stepsOverMarkedLimit = Math.ceil(distanceOverMarkedLimit / baggageService.step);
                    intersectionPrice += baggageService.default_price_for_step * stepsOverMarkedLimit;
                }

                return intersectionPrice;
            },
            getBaggageService() {
                return this.baggage_services_list.find(service => service.id === this.baggage_service_id)
            },
            isBaggageServiceAssigned() {
                return (this.baggage_price_calculation_type === 1 || this.baggage_price_calculation_type === 2) &&
                    !_.isEmpty(this.baggage_prices_update);
            },
            isBaggageServiceSelected() {
                return this.baggage_service_id !== 0 && this.baggage_service_id !== null;
            },
            setBaggageAllowanceFromBaggageService(baggageService) {
                let maxBaggageAllowanceFieldName = 'max_baggage_allowance_local';
                let freeBaggageAllowanceFieldName = 'free_baggage_allowance_local';
                if (this.is_international) {
                    maxBaggageAllowanceFieldName = 'max_baggage_allowance_international';
                    freeBaggageAllowanceFieldName = 'free_baggage_allowance_international';
                }

                this.max_baggage_allowance = baggageService[maxBaggageAllowanceFieldName];
                this.free_baggage_allowance = baggageService[freeBaggageAllowanceFieldName];
            },
            setTripPrice() {
                this.price_for_save = [];
                for (let i = 0; i < this.stations_list.length; i++) {
                    if (i < this.stations_list.length - 1) {
                        for (let j = 0; j < this.stations_list.length; j++) {
                            if (j > i) {
                                if (this.trip_prices[i][j] > 0) {
                                    this.price_for_save.push({
                                        from: this.stations_list[i].station_id,
                                        to: this.stations_list[j].station_id,
                                        price: parseInt(this.trip_prices[i][j])
                                    });
                                }
                            }
                        }
                    }
                }
            },
            setBaggagePrices() {
                this.baggage_prices_for_save = [];
                for (let i = 0; i < this.stations_list.length; i++) {
                    if (i < this.stations_list.length - 1) {
                        for (let j = 0; j < this.stations_list.length; j++) {
                            if (j > i) {
                                if (this.baggage_prices[i][j] > 0) {
                                    this.baggage_prices_for_save.push({
                                        from: this.stations_list[i].station_id,
                                        to: this.stations_list[j].station_id,
                                        price: parseInt(this.baggage_prices[i][j])
                                    });
                                }
                            }
                        }
                    }
                }
            },
            handleRouteChange() {
                let route = this.routes_list.find(item => item.id === this.route_id);
                this.stations_list = route ? route.routes_stations : [];
                this.calculatePrices();

                if (this.isBaggageServiceAssigned()) {
                    this.fillBaggagePricesArray();
                } else {
                    this.fillBaggagePricesWithZero();
                }
            },
            roundAllPrices() {
                for (let i = 0; i < this.stations_list.length; i++) {
                    for (let j = i + 1; j < this.stations_list.length; j++) {
                        this.roundPrice(i, j);
                    }
                }
            },
            roundPrice(i, j) {
                this.trip_prices[i][j] = Math.ceil(this.trip_prices[i][j] / 500) * 500;
                this.fillPreviousPrices(i, j);
                this.$forceUpdate();
            },
            fillPreviousPrices(i, j) {
                for (let k = 0; k < j; k++) {
                    if (this.trip_prices[i][k] === 0) {
                        this.trip_prices[i][k] = this.trip_prices[i][j];
                    }
                }
            }
        },
        computed: {
            formattedDate: function () {
                let date = new Date(this.time);
                return date.getFullYear() + '-' +
                    (date.getMonth() + 1) + '-' +
                    date.getDate() + ' ' + date.getHours() +
                    ':' + date.getMinutes();
            }
        },
        watch: {
            tariff_id: function () {
                this.calculatePrices();
                // this.roundAllPrices();
            },
            loading_item_count(value) {
                if (value === 6) {
                    this.is_loading_item = false
                }
            },
            transporter_id: function (val) {
                this.buses_list = this.all_buses_list.filter(bus => bus.transporter_id === val);
            },
            bus_id: function (val) {
//alx bus autofill
                //let bus = this.all_buses_list.find(item => item.id === val);
                //this.drivers_list = this.all_drivers_list.filter(driver => driver.id === bus.driver_id);
            }
        },
    }

</script>

<style scoped>

</style>
